import { commonViewTexts } from '../common';
import { createDialogCommonViewTexts } from './create-dialog-common';

const targetName = commonViewTexts.user;

export const createNewUserDialogViewTexts = {
  title: `${targetName} 新規登録`,
  descriptions: createDialogCommonViewTexts.messageGenerator(targetName),
  labels: {
    registerer: commonViewTexts.registerer,
    userName: `${targetName}名`,
    email: commonViewTexts.emailAddress,
    password: commonViewTexts.password
  },
  userIsActive: 'ログイン有効'
} as const;
